// Mock Checks Data - İNSANET
// Çek takibi verileri - Geliştirilmiş versiyon

export const checkTypes = [
    { key: 'verilen', label: 'Verilen Çek', color: 'bg-error', textColor: 'text-error' },
    { key: 'alinan', label: 'Alınan Çek', color: 'bg-success', textColor: 'text-success' },
];

export const checkStatuses = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'bg-warning' },
    { key: 'tahsil', label: 'Tahsil Edildi', color: 'bg-success' },
    { key: 'odendi', label: 'Ödendi', color: 'bg-primary' },
    { key: 'gecikti', label: 'Gecikti', color: 'bg-error' },
    { key: 'iade', label: 'İade', color: 'bg-neutral-500' },
];

// Bankalar
export const banks = [
    { key: 'garanti', label: 'Garanti BBVA' },
    { key: 'isbank', label: 'İş Bankası' },
    { key: 'akbank', label: 'Akbank' },
    { key: 'yapikredi', label: 'Yapı Kredi' },
    { key: 'ziraat', label: 'Ziraat Bankası' },
    { key: 'halkbank', label: 'Halkbank' },
    { key: 'vakifbank', label: 'Vakıfbank' },
    { key: 'diger', label: 'Diğer' },
];

// Mock çek verileri - Geliştirilmiş
export const mockChecks = [
    // Verilen Çekler (Bizim verdiğimiz - Gider)
    {
        id: 'chk-1',
        checkNo: 'ÇK-2026-001',
        type: 'verilen',
        issueDate: '2026-01-07',      // Düzenleme tarihi
        dueDate: '2026-02-15',        // Vade tarihi
        recipient: 'YILDIZ İNŞAAT',   // Kime verildi
        supplierId: 'comp-102',       // Gerçek ERP verisi (Kime borçlandık)
        linked_scheduled_payment_id: 'sp-001', // Hangi borca/faturaya istinaden kesildi
        bank: 'garanti',
        amount: 130000,
        status: 'bekliyor',
        description: 'Malzeme bedeli',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-2',
        checkNo: 'ÇK-2026-002',
        type: 'verilen',
        issueDate: '2026-01-07',
        dueDate: '2026-02-20',
        recipient: 'ATLAS YAPI',
        supplierId: 'comp-105',       // Gerçek ERP verisi (Kime borçlandık)
        linked_scheduled_payment_id: 'sp-002', // Hangi borca/faturaya istinaden kesildi
        bank: 'isbank',
        amount: 238000,
        status: 'bekliyor',
        description: 'İşçilik bedeli',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-3',
        checkNo: 'ÇK-2026-003',
        type: 'verilen',
        issueDate: '2026-01-09',
        dueDate: '2026-03-01',
        recipient: 'AKIN HİDROFOR',
        supplierId: 'comp-108',       // Gerçek ERP verisi (Kime borçlandık)
        linked_scheduled_payment_id: 'sp-003', // Hangi borca/faturaya istinaden kesildi
        bank: 'akbank',
        amount: 130000,
        status: 'bekliyor',
        description: 'Hidrofor sistemi',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-4',
        checkNo: 'ÇK-2026-004',
        type: 'verilen',
        issueDate: '2026-01-09',
        dueDate: '2026-03-10',
        recipient: 'MERKEZ TİCARET',
        bank: 'yapikredi',
        amount: 100000,
        status: 'bekliyor',
        description: 'Yapı malzemesi',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },


    {
        id: 'chk-5',
        checkNo: 'ÇK-2025-015',
        type: 'verilen',
        issueDate: '2025-11-12',
        dueDate: '2025-12-15',
        recipient: 'BETO-SAN BETON',
        supplierId: 'comp-101',
        linked_scheduled_payment_id: 'sp-010',
        bank: 'garanti',
        amount: 240000,
        status: 'odendi',
        description: 'Beton dökümü bedeli',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-6',
        checkNo: 'ÇK-2025-016',
        type: 'verilen',
        issueDate: '2025-11-22',
        dueDate: '2025-12-20',
        recipient: 'YILDIZ İNŞAAT',
        supplierId: 'comp-102',
        linked_scheduled_payment_id: 'sp-011',
        bank: 'ziraat',
        amount: 360000,
        status: 'odendi',
        description: 'Taşeron hakedişi (Kaba inşaat)',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-11',
        checkNo: 'ÇK-2025-021',
        type: 'verilen',
        issueDate: '2025-12-10',
        dueDate: '2026-01-20',
        recipient: 'MERMER SANAT',
        supplierId: 'comp-101',
        bank: 'akbank',
        amount: 75000,
        status: 'bekliyor',
        description: 'Mermer işleri',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-12',
        checkNo: 'ÇK-2025-022',
        type: 'verilen',
        issueDate: '2025-12-15',
        dueDate: '2026-02-01',
        recipient: 'ATLAS YAPI',
        bank: 'garanti',
        amount: 300000,
        status: 'bekliyor',
        description: 'Toplu ödeme',
        note: 'Son taksit',
        createdBy: 'Demo Kullanıcı'
    },

    // --- Firmalar.js ile eşleşen supplierId'li verilen çekler (FirmaDetay Çek Portföyü) ---
    {
        id: 'chk-30',
        checkNo: 'ÇK-2025-030',
        type: 'verilen',
        issueDate: '2025-01-01',
        dueDate: '2025-01-15',
        recipient: 'Demir Yapı',
        supplierId: 'comp-1',
        linked_scheduled_payment_id: 'sp3',
        bank: 'garanti',
        amount: 1500000,
        status: 'odendi',
        description: 'Kaba inşaat 5. hakediş çeki',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-31',
        checkNo: 'ÇK-2025-031',
        type: 'verilen',
        issueDate: '2025-11-01',
        dueDate: '2025-11-15',
        recipient: 'Anadolu Beton',
        supplierId: 'comp-4',
        bank: 'isbank',
        amount: 800000,
        status: 'odendi',
        description: 'Beton YP son ödeme çeki',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-32',
        checkNo: 'ÇK-2025-032',
        type: 'verilen',
        issueDate: '2025-09-25',
        dueDate: '2025-10-01',
        recipient: 'İstanbul Demir Çelik',
        supplierId: 'comp-5',
        bank: 'akbank',
        amount: 1500000,
        status: 'odendi',
        description: 'Demir 3. ödeme çeki',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-33',
        checkNo: 'ÇK-2026-033',
        type: 'verilen',
        issueDate: '2026-02-01',
        dueDate: '2026-02-25',
        recipient: 'Alüm-Cam',
        supplierId: 'comp-9',
        linked_scheduled_payment_id: 'sp6',
        bank: 'garanti',
        amount: 450000,
        status: 'bekliyor',
        description: 'Pencere ve doğrama 1. taksit çeki',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-34',
        checkNo: 'ÇK-2026-034',
        type: 'verilen',
        issueDate: '2026-03-01',
        dueDate: '2026-04-01',
        recipient: 'Modern Asansör',
        supplierId: 'comp-6',
        linked_scheduled_payment_id: 'sp18',
        bank: 'yapikredi',
        amount: 400000,
        status: 'bekliyor',
        description: 'Asansör montajı avans çeki',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-35',
        checkNo: 'ÇK-2025-035',
        type: 'verilen',
        issueDate: '2025-07-01',
        dueDate: '2025-07-15',
        recipient: 'Çelik Tesisat',
        supplierId: 'comp-3',
        bank: 'halkbank',
        amount: 1000000,
        status: 'odendi',
        description: 'Tesisat 1. hakediş çeki',
        createdBy: 'Demo Kullanıcı'
    },

    // Alınan Çekler (Müşterilerden - Gelir)
    {
        id: 'chk-16',
        checkNo: 'AL-2025-001',
        type: 'alinan',
        issueDate: '2025-11-30',      // Çekin bize verildiği tarih
        dueDate: '2026-01-30',        // Vade tarihi
        customer: 'AHMET YILMAZ',     // Müşteri adı
        customerId: 'cust-001',       // ERP Data
        linked_sale_installment_id: 'inst-001', // İlgili daire taksit ID'si
        apartment: 'A Blok - Daire 5',
        bank: 'garanti',
        amount: 382000,
        status: 'bekliyor',
        description: 'Daire ödemesi - 1. taksit',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-17',
        checkNo: 'AL-2025-002',
        type: 'alinan',
        issueDate: '2025-11-30',
        dueDate: '2026-02-28',
        customer: 'AYŞE KAYA',
        customerId: 'cust-002',       // ERP Data
        linked_sale_installment_id: 'inst-002', // İlgili daire taksit ID'si
        apartment: 'B Blok - Daire 3',
        bank: 'isbank',
        amount: 381000,
        status: 'bekliyor',
        description: 'Daire ödemesi - 2. taksit',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-18',
        checkNo: 'AL-2025-003',
        type: 'alinan',
        issueDate: '2025-12-15',
        dueDate: '2026-01-15',
        collectedDate: '2026-01-15', // Tahsil edildiği tarih 
        customer: 'MEHMET DEMİR',
        customerId: 'cust-003',       // ERP Data
        linked_sale_installment_id: 'inst-003', // İlgili daire taksit ID'si
        apartment: 'A Blok - Daire 8',
        bank: 'akbank',
        amount: 65000,
        status: 'tahsil',
        description: 'Kaparo',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-19',
        checkNo: 'AL-2025-004',
        type: 'alinan',
        issueDate: '2025-12-20',
        dueDate: '2026-02-20',
        customer: 'ALİ ÖZTÜRK',
        apartment: 'C Blok - Daire 2',
        bank: 'yapikredi',
        amount: 321000,
        status: 'bekliyor',
        description: 'Daire ödemesi - 1. taksit',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-20',
        checkNo: 'AL-2025-005',
        type: 'alinan',
        issueDate: '2025-12-22',
        dueDate: '2026-03-15',
        customer: 'AHMET YILMAZ',
        apartment: 'A Blok - Daire 5',
        bank: 'garanti',
        amount: 82000,
        status: 'bekliyor',
        description: 'Ek ödeme',
        note: 'Tadilat farkı',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-21',
        checkNo: 'AL-2025-006',
        type: 'alinan',
        issueDate: '2025-12-25',
        dueDate: '2026-01-31',
        customer: 'FATİH YILDIZ',
        apartment: 'B Blok - Daire 7',
        bank: 'ziraat',
        amount: 47500,
        status: 'bekliyor',
        description: 'Daire taksiti',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-22',
        checkNo: 'AL-2026-001',
        type: 'alinan',
        issueDate: '2026-01-05',
        dueDate: '2026-03-05',
        customer: 'HASAN ÇELİK',
        apartment: 'A Blok - Daire 12',
        bank: 'halkbank',
        amount: 420000,
        status: 'bekliyor',
        description: 'Daire ödemesi',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-23',
        checkNo: 'AL-2026-002',
        type: 'alinan',
        issueDate: '2026-01-08',
        dueDate: '2026-03-08',
        customer: 'VELİ ARSLAN',
        apartment: 'C Blok - Daire 4',
        bank: 'vakifbank',
        amount: 700000,
        status: 'bekliyor',
        description: 'Daire kaparo',
        note: 'Peşinat',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-24',
        checkNo: 'AL-2026-003',
        type: 'alinan',
        issueDate: '2026-01-08',
        dueDate: '2026-04-08',
        customer: 'VELİ ARSLAN',
        customerId: 'cust-004',
        apartment: 'C Blok - Daire 4',
        bank: 'vakifbank',
        amount: 700000,
        status: 'bekliyor',
        description: 'Daire taksit 2',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-25',
        checkNo: 'AL-2026-004',
        type: 'alinan',
        issueDate: '2025-10-15',
        dueDate: '2025-12-15',
        customer: 'HASAN YILDIRIM',
        customerId: 'cust-005',
        apartment: 'A Blok - Daire 2',
        bank: 'garanti',
        amount: 450000,
        status: 'tahsil',
        description: 'Eski Satış Ödemesi',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
    {
        id: 'chk-26',
        checkNo: 'AL-2026-005',
        type: 'alinan',
        issueDate: '2025-10-15',
        dueDate: '2026-05-15',
        customer: 'HASAN YILDIRIM',
        customerId: 'cust-005',
        apartment: 'A Blok - Daire 2',
        bank: 'isbank',
        amount: 450000,
        status: 'bekliyor',
        description: 'Son Taksit',
        note: '',
        createdBy: 'Demo Kullanıcı'
    },
];

// Helper fonksiyonlar
export const getChecksByType = (type) => {
    if (!type || type === 'all') return mockChecks;
    return mockChecks.filter(c => c.type === type);
};

export const getChecksByStatus = (status) => {
    if (!status || status === 'all') return mockChecks;
    return mockChecks.filter(c => c.status === status);
};

export const getBankLabel = (bankKey) => {
    return banks.find(b => b.key === bankKey)?.label || bankKey;
};

export const getCheckStats = (checks = mockChecks) => {
    const verilenChecks = checks.filter(c => c.type === 'verilen');
    const alinanChecks = checks.filter(c => c.type === 'alinan');

    const bekleyenVerilen = verilenChecks.filter(c => c.status === 'bekliyor');
    const bekleyenAlinan = alinanChecks.filter(c => c.status === 'bekliyor');

    const today = new Date().toISOString().split('T')[0];
    const geciken = checks.filter(c => c.status === 'bekliyor' && c.dueDate < today);

    // Önümüzdeki 7 gün içinde vadesi gelecek çekler
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);
    const nextWeekStr = nextWeek.toISOString().split('T')[0];
    const yaklasan = checks.filter(c => c.status === 'bekliyor' && c.dueDate >= today && c.dueDate <= nextWeekStr);

    return {
        toplamVerilen: verilenChecks.reduce((sum, c) => sum + c.amount, 0),
        toplamAlinan: alinanChecks.reduce((sum, c) => sum + c.amount, 0),
        bekleyenVerilenToplam: bekleyenVerilen.reduce((sum, c) => sum + c.amount, 0),
        bekleyenAlinanToplam: bekleyenAlinan.reduce((sum, c) => sum + c.amount, 0),
        gecikmisToplam: geciken.reduce((sum, c) => sum + c.amount, 0),
        gecikmisAdet: geciken.length,
        yaklasanAdet: yaklasan.length,
        yaklasanToplam: yaklasan.reduce((sum, c) => sum + c.amount, 0),
        verilenAdet: verilenChecks.length,
        alinanAdet: alinanChecks.length,
        tahsilEdilen: alinanChecks.filter(c => c.status === 'tahsil').reduce((sum, c) => sum + c.amount, 0),
        odenen: verilenChecks.filter(c => c.status === 'odendi').reduce((sum, c) => sum + c.amount, 0),
    };
};

export const getUpcomingChecks = (limit = 5) => {
    const today = new Date().toISOString().split('T')[0];
    return [...mockChecks]
        .filter(c => c.status === 'bekliyor' && c.dueDate >= today)
        .sort((a, b) => a.dueDate.localeCompare(b.dueDate))
        .slice(0, limit);
};

export const getOverdueChecks = () => {
    const today = new Date().toISOString().split('T')[0];
    return mockChecks.filter(c => c.status === 'bekliyor' && c.dueDate < today);
};

export default mockChecks;
